import React from 'react';
import validate from 'validate.js';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const validateParkingForm = ({
  description = ''
}, props) => {
  const hasSelectedCleaning = get(props, 'hasSelectedCleaning');

  if (!hasSelectedCleaning) return undefined;

  return {
    description: validate.single(description,
      {
        presence: {
          allowEmpty: false,
          message: (<FormattedMessage id="hosting.validate_cleaning_form.description_error_message" defaultMessage="Please enter a description of your cleaning process" />)
        },
        length: {
          minimum: 50,
          tooShort: (<FormattedMessage id="hosting.validate_cleaning_form.minimum_character_error_message" defaultMessage="Minimum 50 characters"/>),
          maximum: 2000,
          tooLong: (<FormattedMessage id="hosting.validate_cleaning_form.maximum_character_error_message" defaultMessage="Maximum 2000 characters" />)
        }
      })
  };
};

export default validateParkingForm;
